document.addEventListener('DOMContentLoaded', function () {
  function initSwiper(swiperEl) {
    if (!swiperEl.classList.contains('swiper-initialized')) {
      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        breakpoints: {
          330: { slidesPerView: 2.5 },
          430: { slidesPerView: 2.5 },
          768: { slidesPerView: 3.5 },
          1024: { slidesPerView: 4.5 },
        },
      });
    }
  }

  const targetNode = document.querySelector('.related-products, .recently-viewed-products');

  if (targetNode) {
    const observer = new MutationObserver(() => {
      const swiperEl = targetNode.querySelector('.mySwiper');
      if (swiperEl && swiperEl.querySelector('.swiper-slide')) {
        initSwiper(swiperEl);
        observer.disconnect(); // stop once initialized
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }
});

let forYouSwiper = null;

function initForYouSwiper() {
  const el = document.querySelector(".foryou-swiper");

  if (!el) return;

  // Destroy old instance if exists
  if (forYouSwiper) {
    forYouSwiper.destroy(true, true);
  }

  forYouSwiper = new Swiper(el, {
    spaceBetween: 5,
    navigation: {
      nextEl: ".foryou-swiper .swiper-button-next",
      prevEl: ".foryou-swiper .swiper-button-prev",
    },
    breakpoints: {
      330: { slidesPerView: 3 },
      430: { slidesPerView: 3 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    },
  });
}

document.addEventListener("DOMContentLoaded", initForYouSwiper);

const observer = new MutationObserver(() => {
  const el = document.querySelector(".foryou-swiper");

  if (el && !el.classList.contains("swiper-initialized")) {
    initForYouSwiper();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Wishlist
document.addEventListener('DOMContentLoaded', function () {
  const favoriteIcons = document.querySelectorAll('.favorite-icon');
  const favorites = JSON.parse(localStorage.getItem('favorites')) || [];


  //handle the buble icon
  if(favorites.length > 0){
    document.querySelector('.wishlist-count-bubble').style.display = 'block';
    document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
  }else{
    document.querySelector('.wishlist-count-bubble').style.display = 'none';
  }

  
  // Mark already favorited products as active
  favoriteIcons.forEach(icon => {
    const productHandle = icon.getAttribute('data-product-handle');
    if (favorites.includes(productHandle)) {
      icon.classList.add('active');
      icon.querySelector('svg').width = '25.91';
      icon.querySelector('svg').height = '22.95';
      icon.querySelector('svg path').style.fill = '#FFACDB';
      icon.querySelector('svg path').style.fillOpacity  = '1';
    }
  });

  // Handle click on the favorite icon
  favoriteIcons.forEach(icon => {
    icon.addEventListener('click', function () {
      const productHandle = this.getAttribute('data-product-handle');
      const isActive = this.classList.contains('active');

      if (isActive) {
        const index = favorites.indexOf(productHandle);
        if (index > -1) {
          favorites.splice(index, 1);
        }
        this.classList.remove('active');
        this.querySelector('svg').width = '24.24';
        this.querySelector('svg').height = '21.47';
        this.querySelector('svg path').style.fill = '#BAB3B3';
        this.querySelector('svg path').style.fillOpacity  = '0.78';
       
      } else {
        favorites.push(productHandle);
        this.classList.add('active');
         this.querySelector('svg').width = '25.91';
        this.querySelector('svg').height = '22.95';
        this.querySelector('svg path').style.fill = '#FFACDB';
        this.querySelector('svg path').style.fillOpacity  = '1';
      }

      localStorage.setItem('favorites', JSON.stringify(favorites));

       //handle the buble icon
      if(favorites.length > 0){
        document.querySelector('.wishlist-count-bubble').style.display = 'block';
        document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
      }else{
        document.querySelector('.wishlist-count-bubble').style.display = 'none';
      }
    });
  });


  /********* ONLY FOR PDP *********/
  const favoriteIconsProducts = document.querySelectorAll('.favorite-icon-product');
  

  // Mark already favorited products as active
  favoriteIconsProducts.forEach(icon => {
    const productHandle1 = icon.getAttribute('data-product-handle');
    if (favorites.includes(productHandle1)) {
      icon.classList.add('active');
      icon.querySelector('svg path').style.fill = '#000';
      icon.querySelector('svg path').style.stroke = '#000';
      icon.querySelector('svg path').style.fillOpacity  = '1';
    }
  });

  // Handle click on the favorite icon
  favoriteIconsProducts.forEach(icon => {
    icon.addEventListener('click', function () {
      console.log('asdasd');
      const productHandle = this.getAttribute('data-product-handle');
      const isActive = this.classList.contains('active');

      if (isActive) {
        const index = favorites.indexOf(productHandle);
        if (index > -1) {
          favorites.splice(index, 1);
        }
        this.classList.remove('active');
        this.querySelector('svg path').style.fill = 'none';
         this.querySelector('svg path').style.stroke = '#000';
        this.querySelector('svg path').style.fillOpacity  = '1';
       
      } else {
        favorites.push(productHandle);
        this.classList.add('active');
        this.querySelector('svg path').style.fill = '#000';
        this.querySelector('svg path').style.stroke = '#000';
        this.querySelector('svg path').style.fillOpacity  = '1';
      }

      localStorage.setItem('favorites', JSON.stringify(favorites));

       //handle the buble icon
      if(favorites.length > 0){
        document.querySelector('.wishlist-count-bubble').style.display = 'block';
        document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
      }else{
        document.querySelector('.wishlist-count-bubble').style.display = 'none';
      }
      
    });
  });

});

document.addEventListener('DOMContentLoaded', function () {
  const wishlistContainer = document.querySelector('.wishlist-items');
  const favorites = JSON.parse(localStorage.getItem('favorites')) || [];
  
  if (favorites.length === 0 && wishlistContainer ) {
    wishlistContainer.innerHTML = '<tr><td colspan="5">Your wishlist is empty.</td></tr></p>';
    return;
  }

  favorites.forEach( handle => {
    // Fetch product details using product handle or AJAX (adjust as needed)
    fetch(`/products/${handle}.json`)
      .then(response => response.json())
      .then(product => {
        console.log(product.product);
        const productHtml = `
          <tr class="wishlist-item">
            <td><a class="link link--text" href="/products/${handle}"><img src="${product.product.image.src}" width="100px" height="auto" alt="${product.product.title}" /></a></td>
            <td><a class="link link--text" href="/products/${handle}"><h3>${product.product.title}</a></h3></td>
            <td>Start From: $${product.product.variants[0].price}</td>
            <td><a class="button" href="/products/${handle}">View Product</a></td>
            <td><a class="link remove-wishlist" href="javascript:void(0);" data-product-handle="${handle}"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3718 1L1.37183 13M13 13L1 1" stroke="black" stroke-width="1.836032" stroke-linejoin="round"></path>
</svg></a></td>
          </tr>
          
        `;
        if(wishlistContainer){
            wishlistContainer.innerHTML += productHtml;
        }
      
      });
  });
});

//localStorage.removeItem('favorites');
// Remove the Single Item
setTimeout(function(){
  document.querySelectorAll('.remove-wishlist').forEach(button => {
  button.addEventListener('click', function() {
    const productHandleRemove = this.getAttribute('data-product-handle');

    // Remove the item from the wishlist (e.g., update the wishlist in localStorage or call your app's API)
    removeFavoriteByHandle(productHandleRemove);

    // Optionally, remove the item from the DOM
    this.closest('.wishlist-item').remove();
  });
});

function removeFavoriteByHandle(productHandle) {
  // Get the current favorites from localStorage
  let favorites = JSON.parse(localStorage.getItem('favorites')) || [];

  // Find the index of the productHandle in the favorites array
  const index = favorites.indexOf(productHandle);

  // If the productHandle exists in the favorites, remove it
  if (index > -1) {
    favorites.splice(index, 1); // Remove the item from the array
  }

  // Update the favorites in localStorage
  localStorage.setItem('favorites', JSON.stringify(favorites));
  //handle the buble icon
    if(favorites.length > 0){
      document.querySelector('.wishlist-count-bubble').style.display = 'block';
      document.querySelector('.wishlist-count-bubble > span').innerText = favorites.length;
    }else{
      document.querySelector('.wishlist-count-bubble').style.display = 'none';
    }
}
}, 1000);



// document.addEventListener('DOMContentLoaded', function() {
//   // Find all upsell blocks
//   const upsellBlocks = document.querySelectorAll('.cart-item-upsells');

//   upsellBlocks.forEach(block => {
//     const productForm = block.querySelector('.js-product-form');
//     const productJsonEl = block.querySelector('.product-json');

//     if (!productForm || !productJsonEl) return;

//     const productData = JSON.parse(productJsonEl.textContent);
//     const addToCartBtn = productForm.querySelector('.add-to-cart');
//     const hiddenInput = productForm.querySelector('input[name="id"]');
//     const variantOptions = block.querySelectorAll('.variant-option');

//     // If product has only one variant (no dropdowns)
//     if (productData.variants.length === 1) {
//       hiddenInput.value = productData.variants[0].id;
//       addToCartBtn.disabled = false;
//       return;
//     }

//     // Function to match selected variant
//     function getSelectedVariant() {
//       const selected = Array.from(variantOptions).map(opt => opt.value);
//       return productData.variants.find(v => JSON.stringify(v.options) === JSON.stringify(selected));
//     }

//     // Listen for changes on dropdowns
//     variantOptions.forEach(select => {
//       select.addEventListener('change', () => {
//         const variant = getSelectedVariant();

//         if (variant) {
//           hiddenInput.value = variant.id;
//           addToCartBtn.disabled = !variant.available;
//           addToCartBtn.textContent = variant.available ? 'Add to bag' : 'Sold out';
//         } else {
//           hiddenInput.value = '';
//           addToCartBtn.disabled = true;
//           addToCartBtn.textContent = 'Select options';
//         }
//       });
//     });
//   });
// });


document.addEventListener('DOMContentLoaded', function() {
  var nodes = document.querySelectorAll('.product-info-accordion.not-in-quickbuy');
  if(nodes.length > 0) {
    nodes.forEach(function(n) { n.classList.remove('is-last-accordion'); });
    nodes[nodes.length - 1].classList.add('is-last-accordion');
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const searchBar = document.querySelector('.section-header .mobile-top-search');
  const searchIcon = document.querySelector('.section-header .mobile-top-search .show-search-link__icon');

  if (!searchBar || !searchIcon) return;

  // Hide icon initially
  searchIcon.style.display = 'none';

  let manualShow = false; // flag to prevent scroll from hiding immediately after click

  // Click icon → show search bar
  searchIcon.addEventListener('click', function () {
    searchBar.classList.remove('hide');    // remove hide class
    searchBar.style.display = 'flex';      // force display
    searchIcon.style.display = 'none';     // hide icon
    manualShow = true;                     // prevent scroll hiding for a moment

    // Optional: reset flag after short delay
    setTimeout(() => {
      manualShow = false;
    }, 100); // 100ms delay
  });

  // Scroll behavior
  window.addEventListener('scroll', function () {
    if (manualShow) return; // skip scroll hiding if just clicked

    if (window.pageYOffset === 0) {
      // At top → show search bar, hide icon
      searchBar.classList.remove('hide');
      searchBar.style.display = 'flex';
      searchIcon.style.display = 'none';
      return;
    }

    if (window.pageYOffset > 20) {
      // Scroll down → hide search bar, show icon
      searchBar.classList.add('hide');
      searchBar.style.display = 'none';
      searchIcon.style.display = 'flex';
    }
  });
});




document.addEventListener('DOMContentLoaded', function () {

  /* -----------------------------
  SHOW QUICK BUY ON HOVER
  ----------------------------- */
  if (window.matchMedia('(min-width: 1200px)').matches) {

    document.addEventListener('mouseenter', function (e) {

      if (!(e.target instanceof Element)) return;

      const container = e.target.closest('.image-cont');
      if (!container) return;

      const quickBuy = container.querySelector('.quickbuy-container-new');
      if (quickBuy) {
        quickBuy.classList.add('active');
      }

    }, true);

    document.addEventListener('mouseleave', function (e) {

      if (!(e.target instanceof Element)) return;

      const container = e.target.closest('.image-cont');
      if (!container) return;

      const quickBuy = container.querySelector('.quickbuy-container-new');
      if (quickBuy) {
        quickBuy.classList.remove('active');
      }

    }, true);

  }

  document.addEventListener('click', function(e) {

  if (window.innerWidth > 1199) return;

  const trigger = e.target.closest('.quickbuy-toggle.mobile-only-s');
  if (!trigger) return;

  e.preventDefault();

  const variantId = trigger.dataset.variantId;
  const hasOnlyDefault = trigger.dataset.hasOnlyDefault === 'true';

  if (hasOnlyDefault && variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      document.dispatchEvent(
        new CustomEvent('on:cart:change', { bubbles: true })
      );

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.setAttribute('open', '');
    });

    return;
  }

  const container = trigger.closest('.image-cont');
  if (!container) return;

  const quickBuy = container.querySelector('.quickbuy-container-new');
  const overlay = document.querySelector('.overlay');

  if (quickBuy) quickBuy.classList.add('active');
  if (overlay) overlay.classList.add('is-visible');

  document.documentElement.style.overflow = 'hidden';

});

document.addEventListener('click', function(e) {

  if (window.innerWidth > 1199) return;

  const trigger = e.target.closest('.quickbuy-toggle-1.mobile-only-s');
  if (!trigger) return;

  e.preventDefault();

  const variantId = trigger.dataset.variantId;
  const hasOnlyDefault = trigger.dataset.hasOnlyDefault === 'true';

  if (hasOnlyDefault && variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      document.dispatchEvent(
        new CustomEvent('on:cart:change', { bubbles: true })
      );

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.setAttribute('open', '');
    });

    return;
  }

  const container = trigger.closest('.image-cont');
  if (!container) return;

  const quickBuy = container.querySelector('.quickbuy-container-new');

  if (quickBuy) quickBuy.classList.add('active');

});
  /* -----------------------------
  CLOSE QUICK BUY
  ----------------------------- */

  document.addEventListener('click', function(e){

    const closeBtn = e.target.closest('.close-detail-new');
    if(!closeBtn) return;

    const quickBuy = closeBtn.closest('.quickbuy-container-new');

    if(quickBuy){
      quickBuy.classList.remove('active');
    }

  });

  document.addEventListener('click', function(e) {

    if (window.innerWidth > 1199) return;

    const isCloseBtn = e.target.closest('.close-detail-new');
    const isOverlay = e.target.closest('.overlay');

    if (!isCloseBtn && !isOverlay) return;

    // remove all active quickbuy (safe for multiple items)
    document.querySelectorAll('.quickbuy-container-new.active')
      .forEach(el => el.classList.remove('active'));

    const overlay = document.querySelector('.overlay');
    if (overlay) overlay.classList.remove('is-visible');

    document.documentElement.style.overflow = '';

});


  /* -----------------------------
  VARIANT BUTTON CLICK (Buy It Now)
  ----------------------------- */

  document.addEventListener('click', function (e) {

    const label = e.target.closest('.opt-label');
    if (!label) return;

    const quickBuy = label.closest('.quickbuy-container-new');
    if (!quickBuy) return;

    e.preventDefault();

    const inputId = label.getAttribute('for');
    const optBtn = quickBuy.querySelector('#' + inputId);

    if (!optBtn) return;

    if (optBtn.classList.contains('is-unavailable')) return;

    const variantId = optBtn.dataset.valueId;
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(res => res.json())
    .then(() => {

      document.dispatchEvent(
        new CustomEvent('on:cart:change', { bubbles: true })
      );

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.setAttribute('open', '');
        // const overlay = document.querySelector('.overlay');
        // if (overlay) overlay.classList.add('is-visible');
        // document.documentElement.style.overflow = 'hidden';
         document.querySelectorAll('.quickbuy-container-new.active')
      .forEach(el => el.classList.remove('active'));
      }

    });

  });


  /* -----------------------------
  CLOSE CART DRAWER
  ----------------------------- */

  document.addEventListener('click', function(e){

    const closeBtn = e.target.closest('.drawer__close-btn');
    if(!closeBtn) return;

    const cartDrawer = document.querySelector('cart-drawer');

    if(cartDrawer){
      cartDrawer.removeAttribute('open');
      const overlay = document.querySelector('.overlay');
      if (overlay) overlay.classList.remove('is-visible');
      document.documentElement.style.overflow = '';
    }

  });

});

/* RW fix: color switch on desktop gallery */ (function(){var C=customElements.get('carousel-slider');if(!C||C.prototype.__rwFix)return;var p=C.prototype;p.__rwFix=1;var oR=p.refresh;p.refresh=function(){if(this.slider){this.slider.scrollTo({left:0,behavior:'instant'});}return oR.apply(this,arguments);};var oU=p.updateDynamicHeight;p.updateDynamicHeight=function(){if(!this.slides||!this.slides.length)return;if(!(this.currentIndex>=0))this.currentIndex=0;if(this.currentIndex>=this.slides.length)this.currentIndex=this.slides.length-1;return oU.apply(this,arguments);};})();

